import type { FC, ReactElement } from 'react';
import React from 'react';
import cn from 'classnames';
import { useNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';
import type { IProps } from '@alfa-bank/site-main-header/src/models';

import type { TDesktop } from '../../models/desktop';
import { DEFAULT_PROPS } from '../../config';

/**
 * Основная десктоп-версия Главного Баннера.
 */
export const Component: FC<React.PropsWithChildren<TDesktop>> = props => {
    const {
        BannerBackground,
        BannerButton,
        Grid,
        Layout,
        SpacerVertical,
        alignToBottom,
        bannerBenefits,
        bannerBreadcrumbs,
        bannerImage,
        bannerSubMenu,
        bannerSubtitle,
        benefits,
        breadcrumbs,
        children,
        headerTheme,
        renderTitle,
        size = 's',
        styles,
        subMenu,
    } = props;

    const { children: otherChildren, header } = useNamedContainersWithChildren(children);

    return (
        <>
            {header &&
                React.cloneElement(header as ReactElement<IProps>, {
                    defaultTheme: headerTheme,
                })}
            <BannerBackground {...props}>
                {header && (breadcrumbs || subMenu) && (
                    <>
                        <SpacerVertical size="5xl" />
                        <SpacerVertical size="3xl" />
                    </>
                )}
                <Layout>
                    <Grid collapse columnsWidth={[null, '564px']}>
                        <div
                            className={cn(
                                styles.titleWrapper,
                                styles[`bannerSize${size.toUpperCase()}`]
                            )}
                        >
                            <div className={styles.spacedGrid}>
                                {bannerBreadcrumbs(props)}

                                <SpacerVertical size="3xl" />
                                <SpacerVertical size="4xl" />
                                {alignToBottom && <div className={styles.spacer} />}

                                {renderTitle(props)}

                                {bannerSubtitle(props)}
                                {otherChildren}
                                {alignToBottom && <SpacerVertical size="4xl" />}
                            </div>
                            <BannerButton {...props} />
                            {benefits && <SpacerVertical size="5xl" />}
                        </div>
                        <div className={styles.spacedGrid}>
                            {subMenu && bannerSubMenu(props)}
                            {!subMenu && header && (
                                <>
                                    <SpacerVertical size="s" />
                                    <SpacerVertical size="5xl" />
                                </>
                            )}
                            {alignToBottom && <div className={styles.spacer} />}
                            <div className={styles.imageWrapper}>{bannerImage(props)}</div>
                        </div>
                    </Grid>

                    {benefits && (
                        <div className={styles.benefitsWrapper}>{bannerBenefits(props)}</div>
                    )}
                </Layout>
            </BannerBackground>
        </>
    );
};

Component.defaultProps = DEFAULT_PROPS;
